export default __webpack_public_path__ + "1654cbbdac7d69ee6b6964e3e476f47b.png";